module.exports = __webpack_public_path__ + "static/media/lc_green_pattern.637c3cc1.jpg";